module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section main"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.datos), function(dato) {
    return _c('div', {
      staticClass: "column is-4"
    }, [_c('div', {
      staticClass: "panel section"
    }, [_c('div', {
      staticClass: "panel"
    }), _c('p', {
      staticClass: "has-text-centered"
    }, [_c('i', {
      class: [dato.icon, 'icon-block']
    })]), _c('br'), _c('p', [_vm._v(_vm._s(dato.msg))]), _c('br')])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c4a8f6e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/views/SobreMi.pug
// module id = 18
// module chunks = 0